module.exports = __webpack_public_path__ + "img/ROOBET.8c07f583.svg";